import { Select, Option, Box } from '@mui/joy';

const HOURS   = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0')); // 00,05,...,55

// value: 'HH:MM'. onChange: (nextHHMM) => void
export default function TimeSelect5({ value = '10:00', onChange, size = 'sm' }) {
    const [hRaw = '10', mRaw = '00'] = String(value || '10:00').split(':');
    const hh = HOURS.includes(hRaw) ? hRaw : '10';
    // минуты округляем к ближайшим 5 (на случай старых значений вроде 22, 47)
    const mNum = Math.min(55, Math.round((parseInt(mRaw, 10) || 0) / 5) * 5);
    const mm = String(mNum).padStart(2, '0');

    const emit = (nh, nm) => onChange?.(`${nh}:${nm}`);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Select size={size} value={hh} onChange={(_, v) => v && emit(v, mm)}
                sx={{ minWidth: 70, fontWeight: 700 }}>
                {HOURS.map(x => <Option key={x} value={x}>{x}</Option>)}
            </Select>
            <Box sx={{ fontWeight: 800, opacity: 0.6 }}>:</Box>
            <Select size={size} value={mm} onChange={(_, v) => v && emit(hh, v)}
                sx={{ minWidth: 70, fontWeight: 700 }}>
                {MINUTES.map(x => <Option key={x} value={x}>{x}</Option>)}
            </Select>
        </Box>
    );
}